import { toastError } from '../utils/toastMessage';
import API from '../utils/API';

export const sendFiltersSuccess = (data) => {
  return {
    type: 'SEND_FILTERS_SUCCESS',
    data,
  };
};

export const sendFilters = (tagsIds) => {
  const tagsQueryParams = tagsIds.join('|');
  return (dispatch) => {
    API.get(`/dishes?filter=${tagsQueryParams}`)
      .then((response) => {
        dispatch(sendFiltersSuccess(response.data.data.items.dishes.data));
      })
      .catch(() => {
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/sendFilters.js